<script lang="ts">

	import {onMount, beforeUpdate, tick} from "svelte";
    import Footer from "./components/Footer.svelte";
    import Header from "./components/Header.svelte";
    import Route from "./components/Route.svelte";
    import Up from "./components/Up.svelte";
	import Toaster from "./components/Toaster.svelte";
	import Loader from './components/Loader.svelte';
	import { app_version, storeLoader, storeNumberMember, storeNumberEnterprise, storeNumberPartner } from './scripts/store';
	import { setBackendUrl, getCookie } from './scripts/utils';
	import { getUserByToken } from './scripts/apiUsers';
	import { getPartners } from "./scripts/apiEcosystems";
	import { storePartners } from "./scripts/ecosystem";
	import { launchLoader, stopLoader } from "./scripts/utils";
    import { getKeyNumbers } from "./scripts/api";
	import { resetToActivate } from './scripts/login';
    import { redirection } from './scripts/redirection';


	export let name: string;

	beforeUpdate(() => {
		setBackendUrl();
	})

	onMount(async () => {
		launchLoader(500);
		console.log(
			$app_version.app_name + 
			" - version " + $app_version.version);
		if ($storePartners.length <= 0) {
            const loadEcosystem = getPartners();
			storePartners.subscribe(data => {
			})
        }
		if ($storeNumberMember == 0 || $storeNumberEnterprise == 0 || $storeNumberPartner == 0) {
			getKeyNumbers();
		}
		loginWithCookie();
		const urlParams = new URLSearchParams(window.location.search);
    	const isReinit = urlParams.has('reinit');
		if (isReinit) {
    	    resetToActivate();
		} else {
			redirection();
		}
	});

	/**
	 * loginWithCookie
	 */
	function loginWithCookie() {
		const cookieValue = getCookie("cat-login");
		if (cookieValue != undefined && cookieValue != "") {
			const diesePosition = cookieValue.indexOf("#");
			const email = cookieValue.substring(0, diesePosition);
			const token = cookieValue.substring(diesePosition + 1);
			getUserByToken(email, token); 
		}
	}

</script>

<div class="contener font">
	<div class="contener__header"><Header /></div>
	<div class="contener__route"><Route /></div>
	<div class="contener__footer"><Footer /></div>
</div>
<Up />
<Toaster />
<Loader />

<style lang="scss">

	:global(body) {
		display: flex;
		flex-direction: column;
		align-content: center;
		background-color: $color_white;
		padding: 0;
		margin: 0;
		min-height: 100%;
		height: 100%;
		width: 100%;
	}

	:global(html) {
		padding: 0;
		margin: 0;
		overflow: scroll;
		min-height: 100%;
		height: 100%;
		width: 100%;
	}

	.contener {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-content: center;
		width: 100%;
		background-color: $color_white;
		padding: 0;
		margin: 0;
		box-sizing: content-box;
		&__header {
			height: 0px;
		}
		&__route {
			min-height: calc(98vh - 360px);
		}
		&__footer {
			height: 100px;
		}
	}

	@include large {
		.contener {
			&__header {
				height: 130px;
				z-index: 10000;
			}
			&__route {
				min-height: calc(98vh - 500px);
			}
		}
	}

</style>